import { render, staticRenderFns } from "./DestinatarioModalForm.vue?vue&type=template&id=cae04306&"
import script from "./DestinatarioModalForm.vue?vue&type=script&lang=js&"
export * from "./DestinatarioModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports